import styled from 'styled-components';

// Layout only — forest background and peach text color are provided by
// notification.custom via DEFAULT_NOTIFICATION's inline style/bodyStyle.
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 17px;
`;

export const Body = styled.div`
  font-size: 15px;
  line-height: 1.4;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  button {
    height: 36px;
    width: 125px;
  }
`;
